export let JsonOneSectionState = [
    {id: 1,
     img: "img/logo_kompani_1.png",
     head: 'hotbit'},

    {id: 2,
     img: "img/coins-bit.png",
     head: 'coinsbit'},

    {id: 3,
     img: "img/crex25.png",
     head: 'crex24'},
]